"use client";
import * as React from "react";
import Image from "next/image";

import { Box, Container, SxProps, Theme } from "@mui/material";
import Grid from "@mui/material/Grid2";

import OpenTabIcon from "@mui/icons-material/OpenInNewRounded";
import VibeIcon from "@mui/icons-material/TravelExploreRounded";
import SecretsIcon from "@mui/icons-material/TipsAndUpdatesRounded";
import OnboardIcon from "@mui/icons-material/EventAvailableRounded";
import ShipIcon from "@mui/icons-material/DirectionsBoatFilledRounded";

import Link from "next/link";

// import FacebookIcon from "@mui/icons-material/FacebookRounded";

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import SocialIcons from "./SocialIcons";

const HeroBanner = () => {
  return (
    <Box>
      <Box sx={{ bgcolor: "#EDF1FF", mb: { xs: "1rem", md: "3rem" } }}>
        <Box
          sx={{
            bgcolor: "#000C37",
            width: "100%",
            position: "relative",
            overflow: { xs: "hidden", md: "unset" },
          }}
        >
          <Container>
            <Box sx={{ width: "100%", mt: { xs: "2rem", lg: "0rem" } }}>
              <Grid container spacing={2} rowSpacing={{ xs: 3, md: 2 }}>
                <Grid size={{ xs: 12, md: 8, lg: 8.8 }}>
                  <Box sx={{ display: "block", width: "100%" }}>
                    <Box
                      sx={{
                        color: "#fff",
                        fontSize: { xs: "2rem", md: "2.4rem", lg: "3rem", xl: "2.5rem" },
                        fontWeight: 600,
                        fontFamily: "'blauerNue', 'blauerNue Fallback'",
                        mb: "1.2rem",
                        mt: { xs: "1rem", md: "0rem" },
                        lineHeight: 1.2,
                        textWrap: "balance",
                      }}
                    >
                      Sail Confidently Book a Cruise with Ease!
                    </Box>

                    <Box
                      sx={{
                        position: "relative",
                        width: { xs: "100%", sm: "100%" },
                        ".swiper": {
                          width: "100%",
                          overflow: { xs: "visible", sm: "hidden" },
                        },
                      }}
                    >
                      <Swiper
                        spaceBetween={16}
                        slidesPerView={4}
                        breakpoints={{
                          0: {
                            slidesPerView: 1.1,
                          },
                          600: {
                            slidesPerView: 2,
                          },
                          900: {
                            slidesPerView: 3,
                          },
                          1200: {
                            slidesPerView: 4,
                          },
                        }}
                      >
                        <SwiperSlide>
                          <BannerUICard
                            title="Vibe Matching"
                            subTitle="We help you find the cruise that truly fits your style, not just a destination."
                            icon={<VibeIcon />}
                            sx={{
                              bgcolor: "#CCFFEC",
                              ".bn_icon": {
                                color: "#04663F",
                              },
                              ".bn_title": {
                                color: "#00603A",
                              },
                              ".bn_description": {
                                color: "#00603A",
                              },
                            }}
                          />
                        </SwiperSlide>
                        <SwiperSlide>
                          <BannerUICard
                            title="Real time Shore Secrets"
                            subTitle="Get insider tips on hidden gems and local favourites in every port you visit."
                            icon={<SecretsIcon />}
                            sx={{
                              bgcolor: "#EBE0FF",
                              ".bn_icon": {
                                color: "#350097",
                              },
                              ".bn_title": {
                                color: "#350097",
                              },
                              ".bn_description": {
                                color: "#350097",
                              },
                            }}
                          />
                        </SwiperSlide>
                        <SwiperSlide>
                          <BannerUICard
                            title="Seamless Onboard Flow"
                            subTitle="We pre-arrange your cruise activities and dining so you can relax and enjoy."
                            icon={<OnboardIcon />}
                            sx={{
                              bgcolor: "#FFF4D5",
                              ".bn_icon": {
                                color: "#653E00",
                              },
                              ".bn_title": {
                                color: "#653E00",
                              },
                              ".bn_description": {
                                color: "#774900",
                              },
                            }}
                          />
                        </SwiperSlide>
                        <SwiperSlide>
                          <BannerUICard
                            title="Worry-Free Departure & Return"
                            subTitle="Your journey to and from the ship is seamlessly coordinated for worry-free travel."
                            icon={<ShipIcon />}
                            sx={{
                              bgcolor: "#CFF5FF",
                              ".bn_icon": {
                                color: "#002770",
                              },
                              ".bn_title": {
                                color: "#002770",
                              },
                              ".bn_description": {
                                color: "#002770",
                              },
                            }}
                          />
                        </SwiperSlide>
                      </Swiper>
                    </Box>
                  </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 4, lg: 3.2 }}>
                  <Box
                    sx={{
                      display: { xs: "none", md: "flex" },
                      flexDirection: { xs: "column", md: "row" },
                      width: "100%",
                      height: "100%",
                      gap: { xs: "22px", md: "16px" },
                    }}
                  >
                    <Box
                      sx={{
                        bgcolor: "#37457677",
                        height: { xs: "1px", md: "100%" },
                        width: { xs: "100%", md: "1px" },
                        mt: { xs: "0px", md: "0px" },
                      }}
                    ></Box>

                    <CruiseLineCard />
                  </Box>
                </Grid>
              </Grid>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", xl: "row" },
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: { xs: "1rem", md: "3rem", xl: "1rem" },
                mt: { xs: "0rem", md: "2rem", xl: "2rem" },
                mb: "6rem",
              }}
            >
              <Box sx={{}}>
                <Box
                  sx={{
                    color: "#fff",
                    fontSize: "1rem",
                    fontWeight: 600,
                    mb: "10px",
                    mt: { xs: "10px", xl: "0px" },
                    fontFamily: "'blauerNue', 'blauerNue Fallback'",
                    textAlign: { xs: "center", xl: "left" },
                  }}
                >
                  Follow Us for Exclusive Updates!
                </Box>

                <Box>
                  <SocialIcons sx={{ display: "flex", justifyContent: "center" }} />
                </Box>
              </Box>

              <Box sx={{ display: { xs: "none", md: "block" } }}>
                {/* <Divider
                  sx={{
                    "&::before": {
                      borderColor: "#C0BEFF99",
                    },
                    "&::after": {
                      borderColor: "#C0BEFF99",
                    },
                    display: { xs: "none", md: "flex" },
                  }}
                > */}
                <Box
                  sx={{
                    fontFamily: "'blauerNue', 'blauerNue Fallback'",
                    fontSize: "14px",
                    color: "#fff",
                    fontWeight: 400,
                    textAlign: { xs: "center", xl: "right" },
                    a: {
                      color: "#ff1184",
                      svg: {
                        mb: "-6px",
                        width: "21px",
                        height: "21px",
                        ml: "4px",
                      },
                    },
                  }}
                >
                  We offer flexible ways to pay for your dream cruise –{" "}
                  <Link href="/payment">
                    Explore Payment Options!
                    <OpenTabIcon />
                  </Link>
                </Box>
                {/* </Divider> */}

                <Box
                  sx={{
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                    mt: "10px",
                    mb: "16px",
                    // bgcolor: "red",
                    width: { xs: "100%", xl: "800px" },
                    img: {
                      objectFit: "contain",
                      width: "100%",
                      maxWidth: { xs: "100%", md: "900px", xl: "1200px" },
                      height: "auto",
                    },
                  }}
                >
                  <Image
                    src="/images/home/new-design/payment-icons-densed.png"
                    alt="Payment Icons"
                    width={800}
                    height={60}
                    loader={({ src }) => src}
                  />
                </Box>
              </Box>
            </Box>
          </Container>

          <Box sx={{ width: "100%", overflow: "hidden", maxWidth: "100vw" }}>
            <Box
              className="waveWrapper waveAnimation"
              sx={{
                pointerEvents: "none",
                overflow: "hidden",
                position: "absolute",
                left: 0,
                right: 0,
                bottom: 0,
                top: 0,
                zIndex: 3,
                margin: "auto",
                width: { xs: "1100px", md: "100%" },
                ".waveWrapperInner": {
                  position: "absolute",
                  width: "100%",
                  overflow: "hidden",
                  height: "100%",
                  bottom: "-1px",
                },
              }}
            >
              <div className="waveWrapperInner bgTop">
                <Box
                  className="wave waveTop"
                  sx={{ backgroundImage: 'url("/images/home/hero/wave-top.png")' }}
                ></Box>
              </div>
              <div className="waveWrapperInner bgMiddle">
                <Box
                  className="wave waveMiddle"
                  sx={{ backgroundImage: 'url("/images/home/hero/wave-mid.png")' }}
                ></Box>
              </div>
              <div className="waveWrapperInner bgBottom">
                <Box
                  className="wave waveBottom"
                  sx={{ backgroundImage: 'url("/images/home/hero/wave-bot.png")' }}
                ></Box>
              </div>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* <Box sx={{ overflow: "hidden", width: "100%", display: { xs: "none", md: "block" } }}>
        <Container>
          <Divider
            sx={{
              "&::before": {
                borderColor: "#C0BEFF99",
              },
              "&::after": {
                borderColor: "#C0BEFF99",
              },
              display: { xs: "none", md: "flex" },
            }}
          >
            <Box
              sx={{
                fontFamily: "'blauerNue', 'blauerNue Fallback'",
                fontSize: "15px",
                color: "#0B2DB7",
                fontWeight: 600,
              }}
            >
              We offer flexible payment options for your dream cruise – Book with Confidence!
            </Box>
          </Divider>

          <Box
            sx={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              mt: "10px",
              mb: "16px",
              img: {
                objectFit: "contain",
                width: "100%",
                maxWidth: { xs: "100%", md: "900px" },
                height: "auto",
              },
            }}
          >
            <Image
              src="/images/home/new-design/payment-icons.png"
              alt="Payment Icons"
              width={800}
              height={60}
              loader={({ src }) => src}
            />
          </Box>
          <Divider sx={{ borderColor: "#C0BEFF99" }} />
        </Container>
        </Box> */}
    </Box>
  );
};

export default HeroBanner;

const BannerUICard: React.FC<{
  title: string;
  subTitle: string;
  icon: React.ReactNode;
  sx?: SxProps<Theme>;
}> = ({ title, subTitle, icon, sx }) => {
  return (
    <Box
      sx={{
        bgcolor: "#DFC8FD",
        borderRadius: "15px",
        p: "15px",
        position: "relative",
        width: "100%",
        height: { xs: "200px", md: "225px", xl: "200px" },
        ...sx,
      }}
    >
      <Box
        className="bn_icon"
        sx={{
          bgcolor: "#fff",
          width: "40px",
          height: "40px",
          display: "grid",
          placeItems: "center",
          mb: "10px",
          borderRadius: "10px",
        }}
      >
        {icon}
      </Box>
      <Box
        className="bn_title"
        sx={{
          fontWeight: 600,
          fontSize: { xs: "18px", sm: "20px", md: "18px" },
          mb: "8px",
          fontFamily: "'blauerNue', 'blauerNue Fallback'",
          lineHeight: 1.3,
        }}
      >
        {title}
      </Box>
      <Box
        className="bn_description"
        sx={{
          fontWeight: 400,
          fontSize: "14px",
          overflow: "hidden",
          WebkitLineClamp: { xs: 3, sm: 3 },
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          textOverflow: "ellipsis",
          lineHeight: 1.45,
        }}
      >
        {subTitle}
      </Box>
    </Box>
  );
};

export const CruiseLineCard: React.FC = () => {
  return (
    <Box sx={{ width: "100%", display: { xs: "none", md: "block" } }}>
      <Link href="/best-cruise-lines">
        <Box
          sx={{
            width: "100%",
            height: "100%",
            position: "relative",
            overflow: "hidden",
            borderRadius: "20px",
            transition: "all 0.5s",
            border: { xs: "none", md: "4px solid #000C37" },
            "&:hover": {
              border: { xs: "none", md: "4px solid #fff" },
              cursor: "pointer",
            },
          }}
        >
          <Box
            sx={{
              bgcolor: "#FFC325",
              p: "16px 20px 0px",
              width: "100%",
              height: "100%",
              fontFamily: "'blauerNue', 'blauerNue Fallback'",
              position: "absolute",
              zIndex: 1,
            }}
          >
            <Box
              sx={{
                fontSize: "1.8rem",
                fontWeight: 700,
                display: "flex",
                justifyContent: "space-between",
                mb: "8px",
                color: "#060273",
              }}
            >
              <Box>Explore Popular Cruise Lines</Box>
              <OpenTabIcon sx={{ width: "35px", height: "35px" }} />
            </Box>
            <Box sx={{ fontSize: "16px", fontWeight: 400, color: "#8B6400" }}>
              Top Cruise Lines for every adventure
            </Box>
          </Box>

          <Box
            sx={{
              position: "relative",
              zIndex: 1,
              width: "100%",
              minHeight: "260px",
              height: "100%",
              display: "flex",
              alignItems: "flex-end",
              img: {
                width: "100%",
                height: "auto",
                display: "flex",
                objectFit: "contain",
                objectPosition: "0% 100%",
              },
            }}
          >
            <Image
              src="/images/home/demo/cruise-line-bg.png"
              alt="Cruise Lines"
              width={500}
              height={400}
              loader={({ src }) => src}
            />
          </Box>
        </Box>
      </Link>
    </Box>
  );
};
